var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStrikeThrough = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m11.96 5.335 1.954-1.116C11.344-.28 3.938.876 3.938 5.195c0 2.372 1.333 3.202 4.757 4.168l.28.079c.487.138.91.268 1.277.397H0v1.125h12.112c.186.277.263.594.263.981 0 1.42-1.283 2.37-3.21 2.447-1.888.077-3.387-.752-3.551-1.9l-2.228.319c.359 2.508 2.962 3.948 5.87 3.83 3.004-.122 5.369-1.871 5.369-4.696 0-.355-.027-.68-.082-.98H18V9.838h-3.859c-.693-1.2-2.157-1.884-4.553-2.562l-.282-.08c-2.455-.692-3.118-1.105-3.118-2.002 0-1.827 4.268-2.493 5.773.14Z"
})));
export default SvgIconStrikeThrough;